export default __webpack_public_path__ + "static/media/ht.7265c63e.svg";